import { createSlice } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { CookiesStorage } from '../../CookiesStorage/CookiesStorage'
import { ReducersName } from '../ReducersName'
import { SetIsAuthenticationFinished, SetIsLoggedPayload } from './reducer.type'
const storage = new CookiesStorage()

const initialState = {
    isAuthenticationFinished: false,
    isLogged: false,
    isSessionExpired: true,
}

const authenticationReducer = createSlice({
    initialState,
    name: ReducersName.authentication,
    reducers: {
        setIsAuthenticationFinishedAction(
            state,
            { payload: isAuthenticationFinished }: SetIsAuthenticationFinished
        ) {
            state.isAuthenticationFinished = isAuthenticationFinished
        },
        setIsLoggedAction(state, { payload: isLogged }: SetIsLoggedPayload) {
            state.isLogged = isLogged
        },
        setIsSessionExpiredAction(
            state,
            { payload: isLogged }: SetIsLoggedPayload
        ) {
            state.isSessionExpired = isLogged
        },
        logoutAction() {
            storage.removeItem('@ofc:accessToken')
            storage.removeItem('@ofc:msAccessToken')
            storage.removeItem('@ofc:isMS')
            Sentry.setUser(null)
            return initialState
        },
    },
})
const { actions } = authenticationReducer

export const {
    setIsLoggedAction,
    setIsSessionExpiredAction,
    setIsAuthenticationFinishedAction,
    logoutAction,
} = actions

export default authenticationReducer.reducer
